// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
      
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>




//     );


// };

// export default ViewResults;













// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{trainingId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackDocRef = doc(db, "users", userId, "feedback", quizDoc.id);  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackDocRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         {quiz.feedback ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;












// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);


//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{trainingId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackRef = doc(db, "users", userId, "feedback", quizDoc.id);  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();

//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback,
//                                 };
//                             })
//                         );

//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
                                                        
//                                                         {quiz.feedback ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;









// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState(""); // Search term state
//     const navigate = useNavigate(); // Initialize the navigation hook

//     useEffect(() => {
//         const fetchUsersAndQuizzes = async () => {
//             setLoading(true);
//             try {
//                 const usersCollectionRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersCollectionRef);

//                 const usersData = await Promise.all(
//                     usersSnapshot.docs.map(async (userDoc) => {
//                         const userId = userDoc.id;
//                         const userInfo = userDoc.data();

//                         // Fetch quizzes for the user
//                         const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//                         const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//                         // Process quiz data
//                         const quizzes = await Promise.all(
//                             quizzesSnapshot.docs.map(async (quizDoc) => {
//                                 const quizData = quizDoc.data();

//                                 // Fetch training details
//                                 const fetchTrainingDetails = async () => {
//                                     try {
//                                         const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                                         if (trainingDoc.exists()) {
//                                             return {
//                                                 trainingName: trainingDoc.data().name || "Unknown Training",
//                                                 trainingType: trainingDoc.data().type || "General",
//                                             };
//                                         } else {
//                                             toast.error("Training not found!");
//                                             return {
//                                                 trainingName: "Unknown Training",
//                                                 trainingType: "General",
//                                             };
//                                         }
//                                     } catch (error) {
//                                         toast.error("Error fetching training details: " + error.message);
//                                         return {
//                                             trainingName: "Unknown Training",
//                                             trainingType: "General",
//                                         };
//                                     }
//                                 };

                               

//                                 const { trainingName, trainingType } = await fetchTrainingDetails();

                               
//                                 // Fetch feedback for the quiz (located at /users/{userId}/feedback/{quizId})
//                                 const fetchFeedback = async () => {
//                                     try {
//                                         const feedbackRef = doc(db, "users", userId, "feedback");  // feedback is stored with quizId
//                                         const feedbackDoc = await getDoc(feedbackRef);
//                                         return feedbackDoc.exists() ? feedbackDoc.data().feedback : null;
                                        
//                                     } catch (error) {
//                                         toast.error("Error fetching feedback: " + error.message);
//                                         return null;
//                                     }
//                                 };

//                                 const feedback = await fetchFeedback();
                                

                               
//                                 // Adjust score and status for Declaration type
//                                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                                 return {
//                                     id: quizDoc.id,
//                                     name: trainingName,
//                                     score,
//                                     status,
//                                     completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                                     trainingType: adjustedTrainingType,
//                                     feedback, // Store feedback here after fetching
//                                 };
//                             })
//                         );

                        
//                         return {
//                             id: userId,
//                             name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//                             dob: userInfo.dob || "N/A",
//                             phone: userInfo.phone || "N/A",
//                             email: userInfo.email || "N/A",
//                             quizzes,
//                         };
//                     })
//                 );

//                 setUsers(usersData);
//             } catch (error) {
//                 console.error("Error fetching users and quizzes:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUsersAndQuizzes();
//     }, []);

//     // Filter users and quizzes based on search terms
//     const filteredUsers = users.filter((user) => {
//         const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//         return searchKeywords.every((keyword) =>
//             user.name.toLowerCase().includes(keyword) ||
//             user.dob.toLowerCase().includes(keyword) ||
//             user.phone.toLowerCase().includes(keyword) ||
//             user.email.toLowerCase().includes(keyword) ||
//             user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//         );
//     });

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="container mt-4">
//             <h2 className="text-center mb-4">Training Results Dashboard</h2>
//             <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//             {/* Search Bar */}
//             <div className="d-flex justify-content-center mb-4">
//                 <input
//                     type="text"
//                     className="form-control w-50"
//                     placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//                 <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//                     Clear
//                 </button>
//             </div>

//             {/* Display User Cards */}
//             {filteredUsers.length === 0 ? (
//                 <p className="text-center">No users found. Try adjusting your search.</p>
//             ) : (
//                 filteredUsers.map((user) => (
//                     <div key={user.id} className="card mb-4">
//                         <div className="card-header bg-primary text-white">
//                             <h5 className="mb-0">{user.name}</h5>
//                         </div>
//                         <div className="card-body">
//                             {/* User Information */}
//                             <div className="row mb-3">
//                                 <div className="col-md-4">
//                                     <p><strong>Date of Birth:</strong> {user.dob}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Phone:</strong> {user.phone}</p>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <p><strong>Email:</strong> {user.email}</p>
//                                 </div>
//                             </div>

//                             {/* Training Results */}
//                             {user.quizzes.length === 0 ? (
//                                 <p className="text-muted">No training records available.</p>
//                             ) : (
//                                 <div>
//                                     <h6>Training Records:</h6>
//                                     <table className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th>Training Name</th>
//                                                 <th>Type</th>
//                                                 <th>Score</th>
//                                                 <th>Status</th>
//                                                 <th>Completed At</th>
//                                                 <th>Feedback</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
                                            
//                                             {user.quizzes.map((quiz) => (
//                                                 <tr key={quiz.id}>
//                                                     <td>{quiz.name}</td>
//                                                     <td>{quiz.trainingType}</td>
//                                                     <td>{quiz.score}</td>
//                                                     <td>
//                                                         <span
//                                                             className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                                                     ? "bg-success"
//                                                                     : "bg-danger"
//                                                                 }`}
//                                                         >
//                                                             {quiz.status}
//                                                         </span>
//                                                     </td>
//                                                     <td>{quiz.completedAt}</td>
//                                                     <td>
//                                                         {/* Display feedback if available */}
//                                                         {console.log(users)}
//                                                         {quiz.id ? (
//                                                             <button
//                                                                 className="btn btn-outline-secondary btn-sm"
//                                                                 onClick={() =>
//                                                                     navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                                                 }
//                                                             >
//                                                                 View Feedback
//                                                             </button>
//                                                         ) : (
//                                                             <span>No Feedback</span>
//                                                         )}
//                                                     </td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-outline-primary btn-sm"
//                                                             onClick={() =>
//                                                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                                                             }
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// };

// export default ViewResults;















// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";

// const ViewResults = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState(""); // Search term state
//   const navigate = useNavigate(); // Initialize the navigation hook

//   useEffect(() => {
//     const fetchUsersAndQuizzes = async () => {
//       setLoading(true);
//       try {
//         const usersCollectionRef = collection(db, "users");
//         const usersSnapshot = await getDocs(usersCollectionRef);

//         const usersData = await Promise.all(
//           usersSnapshot.docs.map(async (userDoc) => {
//             const userId = userDoc.id;
//             const userInfo = userDoc.data();

//             // Fetch quizzes for the user
//             const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//             const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//             const quizzes = await Promise.all(
//               quizzesSnapshot.docs.map(async (quizDoc) => {
//                 const quizData = quizDoc.data();

//                 // Fetch training details (same logic as before)
//                 const fetchTrainingDetails = async () => {
//                   try {
//                     const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                     if (trainingDoc.exists()) {
//                       return {
//                         trainingName: trainingDoc.data().name || "Unknown Training",
//                         trainingType: trainingDoc.data().type || "General",
//                       };
//                     } else {
//                       toast.error("Training not found!");
//                       return {
//                         trainingName: "Unknown Training",
//                         trainingType: "General",
//                       };
//                     }
//                   } catch (error) {
//                     toast.error("Error fetching training details: " + error.message);
//                     return {
//                       trainingName: "Unknown Training",
//                       trainingType: "General",
//                     };
//                   }
//                 };

//                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                 // Fetch feedback from feedback collection (same approach as ViewFeedbacks.js)
//                 const fetchFeedback = async () => {
//                   try {
//                     const feedbackRef = collection(db, "users", userId, "feedback");
//                     const feedbackSnap = await getDocs(feedbackRef);

//                     const feedbackData = [];
//                     feedbackSnap.forEach((feedbackDoc) => {
//                       feedbackData.push(feedbackDoc.data());
//                     });

//                     return feedbackData;
//                   } catch (error) {
//                     toast.error("Error fetching feedback: " + error.message);
//                     return [];
//                   }
//                 };

//                 const feedback = await fetchFeedback();

//                 // Adjust score and status for Declaration type
//                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                 return {
//                   id: quizDoc.id,
//                   name: trainingName,
//                   score,
//                   status,
//                   completedAt: quizData.completedAt?.toDate().toLocaleDateString() || "N/A",
//                   trainingType: adjustedTrainingType,
//                   feedback, // Store feedback here after fetching
//                 };
//               })
//             );

//             return {
//               id: userId,
//               name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//               dob: userInfo.dob || "N/A",
//               phone: userInfo.phone || "N/A",
//               email: userInfo.email || "N/A",
//               quizzes,
//             };
//           })
//         );

//         setUsers(usersData);
//       } catch (error) {
//         console.error("Error fetching users and quizzes:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsersAndQuizzes();
//   }, []);

//   // Filter users and quizzes based on search terms
//   const filteredUsers = users.filter((user) => {
//     const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//     return searchKeywords.every((keyword) =>
//       user.name.toLowerCase().includes(keyword) ||
//       user.dob.toLowerCase().includes(keyword) ||
//       user.phone.toLowerCase().includes(keyword) ||
//       user.email.toLowerCase().includes(keyword) ||
//       user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//     );
//   });

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="container mt-4">
//       <h2 className="text-center mb-4">Training Results Dashboard</h2>
//       <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//       {/* Search Bar */}
//       <div className="d-flex justify-content-center mb-4">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//           Clear
//         </button>
//       </div>

//       {/* Display User Cards */}
//       {filteredUsers.length === 0 ? (
//         <p className="text-center">No users found. Try adjusting your search.</p>
//       ) : (
//         filteredUsers.map((user) => (
//           <div key={user.id} className="card mb-4">
//             <div className="card-header bg-primary text-white">
//               <h5 className="mb-0">{user.name}</h5>
//             </div>
//             <div className="card-body">
//               {/* User Information */}
//               <div className="row mb-3">
//                 <div className="col-md-4">
//                   <p><strong>Date of Birth:</strong> {user.dob}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Phone:</strong> {user.phone}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Email:</strong> {user.email}</p>
//                 </div>
//               </div>

//               {/* Training Results */}
//               {user.quizzes.length === 0 ? (
//                 <p className="text-muted">No training records available.</p>
//               ) : (
//                 <div>
//                   <h6>Training Records:</h6>
//                   <table className="table table-striped">
//                     <thead>
//                       <tr>
//                         <th>Training Name</th>
//                         <th>Type</th>
//                         <th>Score</th>
//                         <th>Status</th>
//                         <th>Completed At</th>
//                         <th>Feedback</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {user.quizzes.map((quiz) => (
//                         <tr key={quiz.id}>
//                           <td>{quiz.name}</td>
//                           <td>{quiz.trainingType}</td>
//                           <td>{quiz.score}</td>
//                           <td>
//                             <span
//                               className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                 ? "bg-success"
//                                 : "bg-danger"
//                               }`}
//                             >
//                               {quiz.status}
//                             </span>
//                           </td>
//                           <td>{quiz.completedAt}</td>
//                           <td>
//                             {/* Display feedback if available */}
//                             {quiz.feedback.length > 0 ? (
//                               <button
//                                 className="btn btn-outline-secondary btn-sm"
//                                 onClick={() =>
//                                   navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                 }
//                               >
//                                 View Feedback
//                               </button>
//                             ) : (
//                               <span>No Feedback</span>
//                             )}
//                           </td>
//                           <td>
//                             <button
//                               className="btn btn-outline-primary btn-sm"
//                               onClick={() =>
//                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                               }
//                             >
//                               View
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default ViewResults;












// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";
// import Spinner from "react-bootstrap/Spinner";



// const fetchAllRetakes = async (userId, trainingId) => {
//   try {
//     const retakeCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
//     const retakeDocs = await getDocs(retakeCollectionRef);

//     // Convert documents to an array of retake objects
//     const retakes = retakeDocs.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(), // Spread all fields from Firestore
//     }));

//     return retakes;
//   } catch (error) {
//     console.error(`Error fetching retakes for ${trainingId}:`, error);
//     return [];
//   }
// };




// const ViewResults = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState(""); // Search term state
//   const navigate = useNavigate(); // Initialize the navigation hook

//   useEffect(() => {
//     const fetchUsersAndQuizzes = async () => {
//       setLoading(true);
//       try {
//         const usersCollectionRef = collection(db, "users");
//         const usersSnapshot = await getDocs(usersCollectionRef);

//         const usersData = await Promise.all(
//           usersSnapshot.docs.map(async (userDoc) => {
//             const userId = userDoc.id;
//             const userInfo = userDoc.data();

//             // Fetch quizzes for the user
//             const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//             const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//             const quizzes = await Promise.all(
//               quizzesSnapshot.docs.map(async (quizDoc) => {
//                 const quizData = quizDoc.data();

//                 // Fetch training details (same logic as before)
//                 const fetchTrainingDetails = async () => {
//                   try {
//                     const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                     if (trainingDoc.exists()) {
//                       return {
//                         trainingName: trainingDoc.data().name || "Unknown Training",
//                         trainingType: trainingDoc.data().type || "General",
//                       };
//                     } else {
//                       toast.error("Training not found!");
//                       return {
//                         trainingName: "Unknown Training",
//                         trainingType: "General",
//                       };
//                     }
//                   } catch (error) {
//                     toast.error("Error fetching training details: " + error.message);
//                     return {
//                       trainingName: "Unknown Training",
//                       trainingType: "General",
//                     };
//                   }
//                 };

//                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                 // Fetch feedback from feedback collection (this part has been modified)
//                 const fetchFeedback = async () => {
//                   try {
//                     const feedbackRef = collection(db, "users", userId, "feedback");
//                     const feedbackSnap = await getDocs(feedbackRef);

//                     // Collect feedback data
//                     let feedbackData = null;
//                     feedbackSnap.forEach((feedbackDoc) => {
//                       if (feedbackDoc.id === quizDoc.id) {
//                         feedbackData = feedbackDoc.data();
//                       }
//                     });

//                     return feedbackData;
//                   } catch (error) {
//                     toast.error("Error fetching feedback: " + error.message);
//                     return null;
//                   }
//                 };

//                 const feedback = await fetchFeedback();

//                 // Adjust score and status for Declaration type
//                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

                

//                 return {
//                   id: quizDoc.id,
//                   name: trainingName,
//                   score,
//                   status,
//                   completedAt: quizData.completedAt,
//                   trainingType: adjustedTrainingType,
//                   feedback, // Store the actual feedback here
//                 };
//               })
//             );

//             return {
//               id: userId,
//               name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//               dob: userInfo.dob || "N/A",
//               phone: userInfo.phone || "N/A",
//               email: userInfo.email || "N/A",
//               quizzes,
//             };
//           })
//         );

//         setUsers(usersData);
//       } catch (error) {
//         console.error("Error fetching users and quizzes:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsersAndQuizzes();
//   }, []);


//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle empty or undefined date
//     const date = new Date(dateString);  // Convert string to Date object

//     const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
//     const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
//     const year = date.getFullYear();  // Get year

//     return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
//   };

//   // Filter users and quizzes based on search terms
//   const filteredUsers = users.filter((user) => {
//     const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//     return searchKeywords.every((keyword) =>
//       user.name.toLowerCase().includes(keyword) ||
//       user.dob.toLowerCase().includes(keyword) ||
//       user.phone.toLowerCase().includes(keyword) ||
//       user.email.toLowerCase().includes(keyword) ||
//       user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//     );
//   });

//   if (loading) {
//     return <div><div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
//     <Spinner animation="border" variant="primary" />
//   </div></div>;
//   }

//   return (
//     <div className="container mt-4">
//       <h2 className="text-center mb-4">Training Results Dashboard</h2>
//       <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//       {/* Search Bar */}
//       <div className="d-flex justify-content-center mb-4">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//           Clear
//         </button>
//       </div>

//       {/* Display User Cards */}
//       {filteredUsers.length === 0 ? (
//         <p className="text-center">No users found. Try adjusting your search.</p>
//       ) : (
//         filteredUsers.map((user) => (
//           <div key={user.id} className="card mb-4">
//             <div className="card-header bg-primary text-white">
//               <h5 className="mb-0">{user.name}</h5>
//             </div>
//             <div className="card-body">
//               {/* User Information */}
//               <div className="row mb-3">
//                 <div className="col-md-4">
//                   <p><strong>Date of Birth:</strong> {user.dob}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Phone:</strong> {user.phone}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Email:</strong> {user.email}</p>
//                 </div>
//               </div>

//               {/* Training Results */}
//               {user.quizzes.length === 0 ? (
//                 <p className="text-muted">No training records available.</p>
//               ) : (
//                 <div>
//                   <h6>Training Records:</h6>
//                   <table className="table table-striped">
//                     <thead>
//                       <tr>
//                         <th>Training Name</th>
//                         <th>Type</th>
//                         <th>Score</th>
//                         <th>Status</th>
//                         <th>Completed At</th>
//                         <th>Feedback</th>
//                         <th>Download</th>
//                         <th>Retakes</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {user.quizzes.map((quiz) => (
//                         <tr key={quiz.id}>
//                           <td>{quiz.name}</td>
//                           <td>{quiz.trainingType}</td>
//                           <td>{quiz.score}</td>
//                           <td>
//                             <span
//                               className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                 ? "bg-success"
//                                 : "bg-danger"
//                               }`}
//                             >
//                               {quiz.status}
//                             </span>
//                           </td>
//                           <td>{formatDate(quiz.completedAt)}</td>
//                           <td>
//                             {/* Display feedback if available */}
//                             {quiz.feedback ? (
//                               <button
//                                 className="btn btn-outline-secondary btn-sm"
//                                 onClick={() =>
//                                   navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                 }
//                               >
//                                 View Feedback
//                               </button>
//                             ) : (
//                               <span>No Feedback</span>
//                             )}
//                           </td>
//                           <td>
//                             <button
//                               className="btn btn-outline-primary btn-sm"
//                               onClick={() =>
//                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                               }
//                             >
//                               Download
//                             </button>
//                           </td>
//                           <td>
//                           {quiz ? (
//                            <button
//                               className="btn btn-outline-primary btn-sm"
//                               onClick={() =>
//                                 navigate(`/view-retake-training-result/${user.id}/${quiz.id}`)
//                               }
//                             > 
//                             Download Retake 
//                             </button> 
//                           ):(
//                             <span></span>
//                           )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default ViewResults;





































//Hello final code




// import React, { useState, useEffect } from "react";
// import { db } from "../firebase"; // Firebase configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom"; // Import navigation hook
// import { toast } from "react-toastify";
// import Spinner from "react-bootstrap/Spinner";

// // Function to fetch retakes information
// const fetchAllRetakes = async (userId, trainingId) => {
//   try {
//     const retakeCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
//     const retakeDocs = await getDocs(retakeCollectionRef);

//     // Convert documents to an array of retake objects
//     const retakes = retakeDocs.docs.map((doc) => ({
//       id: doc.id,
//       ...doc.data(), // Spread all fields from Firestore
//     }));

//     return retakes;
//   } catch (error) {
//     console.error(`Error fetching retakes for ${trainingId}:`, error);
//     return [];
//   }
// };

// const ViewResults = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState(""); // Search term state
//   const navigate = useNavigate(); // Initialize the navigation hook

//   useEffect(() => {
//     const fetchUsersAndQuizzes = async () => {
//       setLoading(true);
//       try {
//         const usersCollectionRef = collection(db, "users");
//         const usersSnapshot = await getDocs(usersCollectionRef);

//         const usersData = await Promise.all(
//           usersSnapshot.docs.map(async (userDoc) => {
//             const userId = userDoc.id;
//             const userInfo = userDoc.data();

//             // Fetch quizzes for the user
//             const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
//             const quizzesSnapshot = await getDocs(quizzesCollectionRef);

//             const quizzes = await Promise.all(
//               quizzesSnapshot.docs.map(async (quizDoc) => {
//                 const quizData = quizDoc.data();

//                 // Fetch training details
//                 const fetchTrainingDetails = async () => {
//                   try {
//                     const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
//                     if (trainingDoc.exists()) {
//                       return {
//                         trainingName: trainingDoc.data().name || "Unknown Training",
//                         trainingType: trainingDoc.data().type || "General",
//                       };
//                     } else {
//                       toast.error("Training not found!");
//                       return {
//                         trainingName: "Unknown Training",
//                         trainingType: "General",
//                       };
//                     }
//                   } catch (error) {
//                     toast.error("Error fetching training details: " + error.message);
//                     return {
//                       trainingName: "Unknown Training",
//                       trainingType: "General",
//                     };
//                   }
//                 };

//                 const { trainingName, trainingType } = await fetchTrainingDetails();

//                 // Fetch feedback
//                 const fetchFeedback = async () => {
//                   try {
//                     const feedbackRef = collection(db, "users", userId, "feedback");
//                     const feedbackSnap = await getDocs(feedbackRef);

//                     // Collect feedback data
//                     let feedbackData = null;
//                     feedbackSnap.forEach((feedbackDoc) => {
//                       if (feedbackDoc.id === quizDoc.id) {
//                         feedbackData = feedbackDoc.data();
//                       }
//                     });

//                     return feedbackData;
//                   } catch (error) {
//                     toast.error("Error fetching feedback: " + error.message);
//                     return null;
//                   }
//                 };

//                 const feedback = await fetchFeedback();

//                 // Adjust score and status for Declaration type
//                 const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
//                 const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
//                 const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

//                 // Fetch retakes data
//                 const retakes = await fetchAllRetakes(userId, quizDoc.id);

//                 return {
//                   id: quizDoc.id,
//                   name: trainingName,
//                   score,
//                   status,
//                   completedAt: quizData.completedAt,
//                   trainingType: adjustedTrainingType,
//                   feedback, // Store the actual feedback here
//                   retakes,  // Store retakes data here
//                 };
//               })
//             );

//             return {
//               id: userId,
//               name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
//               dob: userInfo.dob || "N/A",
//               phone: userInfo.phone || "N/A",
//               email: userInfo.email || "N/A",
//               quizzes,
//             };
//           })
//         );

//         setUsers(usersData);
//       } catch (error) {
//         console.error("Error fetching users and quizzes:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUsersAndQuizzes();
//   }, []);

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle empty or undefined date
//     const date = new Date(dateString);  // Convert string to Date object

//     const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
//     const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
//     const year = date.getFullYear();  // Get year

//     return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
//   };

//   // Filter users and quizzes based on search terms
//   const filteredUsers = users.filter((user) => {
//     const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
//     return searchKeywords.every((keyword) =>
//       user.name.toLowerCase().includes(keyword) ||
//       user.dob.toLowerCase().includes(keyword) ||
//       user.phone.toLowerCase().includes(keyword) ||
//       user.email.toLowerCase().includes(keyword) ||
//       user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
//     );
//   });

//   if (loading) {
//     return (
//       <div>
//         <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
//           <Spinner animation="border" variant="primary" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4">
//       <h2 className="text-center mb-4">Training Results Dashboard</h2>
//       <p className="text-muted text-center">Search and review training results by learner or training details.</p>

//       {/* Search Bar */}
//       <div className="d-flex justify-content-center mb-4">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search by Name, DOB, Email, Phone, or Training Name"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
//           Clear
//         </button>
//       </div>

//       {/* Display User Cards */}
//       {filteredUsers.length === 0 ? (
//         <p className="text-center">No users found. Try adjusting your search.</p>
//       ) : (
//         filteredUsers.map((user) => (
//           <div key={user.id} className="card mb-4">
//             <div className="card-header bg-primary text-white">
//               <h5 className="mb-0">{user.name}</h5>
//             </div>
//             <div className="card-body">
//               {/* User Information */}
//               <div className="row mb-3">
//                 <div className="col-md-4">
//                   <p><strong>Date of Birth:</strong> {user.dob}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Phone:</strong> {user.phone}</p>
//                 </div>
//                 <div className="col-md-4">
//                   <p><strong>Email:</strong> {user.email}</p>
//                 </div>
//               </div>

//               {/* Training Results */}
//               {user.quizzes.length === 0 ? (
//                 <p className="text-muted">No training records available.</p>
//               ) : (
//                 <div>
//                   <h6>Training Records:</h6>
//                   <table className="table table-striped">
//                     <thead>
//                       <tr>
//                         <th>Training Name</th>
//                         <th>Type</th>
//                         <th>Score</th>
//                         <th>Status</th>
//                         <th>Completed At</th>
//                         <th>Feedback</th>
//                         <th>Download</th>
//                         <th>Retakes</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {user.quizzes.map((quiz) => (
//                         <tr key={quiz.id}>
//                           <td>{quiz.name}</td>
//                           <td>{quiz.trainingType}</td>
//                           <td>{quiz.score}</td>
//                           <td>
//                             <span
//                               className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
//                                 ? "bg-success"
//                                 : "bg-danger"
//                               }`}
//                             >
//                               {quiz.status}
//                             </span>
//                           </td>
//                           <td>{formatDate(quiz.completedAt)}</td>
//                           <td>
//                             {/* Display feedback if available */}
//                             {quiz.feedback ? (
//                               <button
//                                 className="btn btn-outline-secondary btn-sm"
//                                 onClick={() =>
//                                   navigate(`/view-feedback/${user.id}/${quiz.id}`)
//                                 }
//                               >
//                                 View Feedback
//                               </button>
//                             ) : (
//                               <span>No Feedback</span>
//                             )}
//                           </td>
//                           <td>
//                             <button
//                               className="btn btn-outline-primary btn-sm"
//                               onClick={() =>
//                                 navigate(`/view-training-result/${user.id}/${quiz.id}`)
//                               }
//                             >
//                               Download
//                             </button>
//                           </td>
//                           <td>
//                             {quiz.retakes.length > 0 ? (
//                               <button
//                                 className="btn btn-outline-primary btn-sm"
//                                 onClick={() =>
//                                   navigate(`/view-retake-training-result/${user.id}/${quiz.id}`)
//                                 }
//                               >
//                                 Download Retakes
//                               </button>
//                             ) : (
//                               <span>No Retakes</span>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default ViewResults;

















import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

// Function to fetch retakes information
const fetchAllRetakes = async (userId, trainingId) => {
  try {
    const retakeCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
    const retakeDocs = await getDocs(retakeCollectionRef);

    const retakes = retakeDocs.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return retakes;
  } catch (error) {
    console.error(`Error fetching retakes for ${trainingId}:`, error);
    return [];
  }
};

const ViewResults = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Number of users per page
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsersAndQuizzes = async () => {
      setLoading(true);
      try {
        const usersCollectionRef = collection(db, "users");
        const usersSnapshot = await getDocs(usersCollectionRef);

        const usersData = await Promise.all(
          usersSnapshot.docs.map(async (userDoc) => {
            const userId = userDoc.id;
            const userInfo = userDoc.data();

            const quizzesCollectionRef = collection(db, "users", userId, "quizzes");
            const quizzesSnapshot = await getDocs(quizzesCollectionRef);

            const quizzes = await Promise.all(
              quizzesSnapshot.docs.map(async (quizDoc) => {
                const quizData = quizDoc.data();

                const fetchTrainingDetails = async () => {
                  try {
                    const trainingDoc = await getDoc(doc(db, "trainings", quizDoc.id));
                    if (trainingDoc.exists()) {
                      return {
                        trainingName: trainingDoc.data().name || "Unknown Training",
                        trainingType: trainingDoc.data().type || "General",
                      };
                    } else {
                      toast.error("Training not found!");
                      return {
                        trainingName: "Unknown Training",
                        trainingType: "General",
                      };
                    }
                  } catch (error) {
                    toast.error("Error fetching training details: " + error.message);
                    return {
                      trainingName: "Unknown Training",
                      trainingType: "General",
                    };
                  }
                };

                const { trainingName, trainingType } = await fetchTrainingDetails();

                const fetchFeedback = async () => {
                  try {
                    const feedbackRef = collection(db, "users", userId, "feedback");
                    const feedbackSnap = await getDocs(feedbackRef);

                    let feedbackData = null;
                    feedbackSnap.forEach((feedbackDoc) => {
                      if (feedbackDoc.id === quizDoc.id) {
                        feedbackData = feedbackDoc.data();
                      }
                    });

                    return feedbackData;
                  } catch (error) {
                    toast.error("Error fetching feedback: " + error.message);
                    return null;
                  }
                };

                const feedback = await fetchFeedback();

                const adjustedTrainingType = trainingType.charAt(0).toUpperCase() + trainingType.slice(1).toLowerCase();
                const score = adjustedTrainingType === "Declaration" ? "Not Required" : quizData.score || 0;
                const status = adjustedTrainingType === "Declaration" ? "Signed" : quizData.score >= 15 ? "Pass" : "Fail";

                const retakes = await fetchAllRetakes(userId, quizDoc.id);

                return {
                  id: quizDoc.id,
                  name: trainingName,
                  score,
                  status,
                  completedAt: quizData.completedAt,
                  trainingType: adjustedTrainingType,
                  feedback,
                  retakes,
                };
              })
            );

            return {
              id: userId,
              name: userInfo.firstName + " " + userInfo.lastName || "Unknown User",
              dob: userInfo.dob || "N/A",
              phone: userInfo.phone || "N/A",
              email: userInfo.email || "N/A",
              quizzes,
            };
          })
        );

        setUsers(usersData);
        setFilteredUsers(usersData);
      } catch (error) {
        console.error("Error fetching users and quizzes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersAndQuizzes();
  }, []);

  // Filter users based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers(users);
      setCurrentPage(1);
    } else {
      const searchKeywords = searchTerm.toLowerCase().split(" ").filter(Boolean);
      const filtered = users.filter((user) =>
        searchKeywords.every((keyword) =>
          user.name.toLowerCase().includes(keyword) ||
          user.dob.toLowerCase().includes(keyword) ||
          user.phone.toLowerCase().includes(keyword) ||
          user.email.toLowerCase().includes(keyword) ||
          user.quizzes.some((quiz) => quiz.name.toLowerCase().includes(keyword))
        )
      );
      setFilteredUsers(filtered);
      setCurrentPage(1);
    }
  }, [searchTerm, users]);

  // Pagination logic
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Function to handle download button click (opens in new tab)
  const handleDownload = (userId, quizId) => {
    const url = `/view-training-result/${userId}/${quizId}`;
    window.open(url, '_blank');
  };

  // Function to handle retakes download button click (opens in new tab)
  const handleRetakesDownload = (userId, quizId) => {
    const url = `/view-retake-training-result/${userId}/${quizId}`;
    window.open(url, '_blank');
  };

  // Function to handle feedback view (opens in new tab)
  const handleViewFeedback = (userId, quizId) => {
    const url = `/view-feedback/${userId}/${quizId}`;
    window.open(url, '_blank');
  };

  // Pagination component
  const Pagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>
          
          {pageNumbers.map(number => (
            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
              <button
                className="page-link"
                onClick={() => paginate(number)}
              >
                {number}
              </button>
            </li>
          ))}
          
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">Training Results Dashboard</h2>
      <p className="text-muted text-center">Search and review training results by learner or training details.</p>

      {/* Search Bar */}
      <div className="d-flex justify-content-center mb-4">
        <input
          type="text"
          className="form-control w-50"
          placeholder="Search by Name, DOB, Email, Phone, or Training Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className="btn btn-secondary ms-2" onClick={() => setSearchTerm("")}>
          Clear
        </button>
      </div>

      {/* Results Count */}
      <div className="row mb-3">
        <div className="col-12">
          <p className="text-muted">
            Showing {indexOfFirstUser + 1}-{Math.min(indexOfLastUser, filteredUsers.length)} of {filteredUsers.length} users
          </p>
        </div>
      </div>

      {/* Display User Cards */}
      {currentUsers.length === 0 ? (
        <p className="text-center">No users found. Try adjusting your search.</p>
      ) : (
        <>
          {currentUsers.map((user) => (
            <div key={user.id} className="card mb-4">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">{user.name}</h5>
              </div>
              <div className="card-body">
                {/* User Information */}
                <div className="row mb-3">
                  <div className="col-md-4">
                    <p><strong>Date of Birth:</strong> {user.dob}</p>
                  </div>
                  <div className="col-md-4">
                    <p><strong>Phone:</strong> {user.phone}</p>
                  </div>
                  <div className="col-md-4">
                    <p><strong>Email:</strong> {user.email}</p>
                  </div>
                </div>

                {/* Training Results */}
                {user.quizzes.length === 0 ? (
                  <p className="text-muted">No training records available.</p>
                ) : (
                  <div>
                    <h6>Training Records:</h6>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Training Name</th>
                            <th>Type</th>
                            <th>Score</th>
                            <th>Status</th>
                            <th>Completed At</th>
                            <th>Feedback</th>
                            <th>Download</th>
                            <th>Retakes</th>
                          </tr>
                        </thead>
                        <tbody>
                          {user.quizzes.map((quiz) => (
                            <tr key={quiz.id}>
                              <td>{quiz.name}</td>
                              <td>{quiz.trainingType}</td>
                              <td>{quiz.score}</td>
                              <td>
                                <span
                                  className={`badge ${quiz.status === "Pass" || quiz.status === "Signed"
                                    ? "bg-success"
                                    : "bg-danger"
                                  }`}
                                >
                                  {quiz.status}
                                </span>
                              </td>
                              <td>{formatDate(quiz.completedAt)}</td>
                              <td>
                                {quiz.feedback ? (
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => handleViewFeedback(user.id, quiz.id)}
                                  >
                                    View Feedback
                                  </button>
                                ) : (
                                  <span>No Feedback</span>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => handleDownload(user.id, quiz.id)}
                                >
                                  Download
                                </button>
                              </td>
                              <td>
                                {quiz.retakes.length > 0 ? (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => handleRetakesDownload(user.id, quiz.id)}
                                  >
                                    Download Retakes
                                  </button>
                                ) : (
                                  <span>No Retakes</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* Pagination */}
          {totalPages > 1 && <Pagination />}
        </>
      )}
    </div>
  );
};

export default ViewResults;



















